export class SystemRoles {
  public static rolePrincipalRepresentative = 'legalEntityPrincipalRepresentative';
  public static roleExternalRepresentative = 'legalEntityExternalRepresentative';
  public static roleMember = 'member';
  public static roleStudent = 'student';
  public static roleDentalAssistantUnconfirmed = 'dentalAssistantUnconfirmed';
  public static roleDentalAssistant  = 'dentalAssistant';
  public static roleGeneralPublic = 'GeneralPublic';
}